import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {IsAnonymousGuard} from '@portal-commons/guards/is-anonymous.guard';
import {IsAuthenticatedGuard} from '@portal-commons/guards/is-authenticated.guard';
import {SecondaryNavigationComponent} from './misc/secondary-navigation/secondary-navigation.component';

export const routes: Routes = [
  {
    path: 'portal',
    redirectTo: '',
    pathMatch: 'prefix',
  },
  {
    path: '',
    loadChildren: () => import('./portal/portal.module').then(module => module.PortalModule),
    canActivateChild: [IsAuthenticatedGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(module => module.LoginModule),
    data: {
      title: 'Ihr Service Portal',
      description:
        'Herzlich willkommen zu unserem digitalen Kundenservice ► Verwalten Sie Ihre Finanzierungs- und Leasingverträge online ✓ Hier mehr erfahren!',
    },
    canActivateChild: [IsAnonymousGuard],
  },
  {
    path: 'registration',
    loadChildren: () => import('./registration/registration.module').then(module => module.RegistrationModule),
    data: {
      title: 'Registrierung',
      description:
        'Herzlich willkommen zu unserem digitalen Kundenservice ► Hier registrieren und Ihre Finanzierungs- und Leasingverträge online verwalten ✓',
    },
    canActivateChild: [IsAnonymousGuard],
  },
  {
    path: 'misc',
    loadChildren: () => import('./misc/misc.module').then(module => module.MiscModule),
  },
  {
    path: 'bankmodule',
    loadChildren: () => import('./bankmodule/bankmodule.module').then(module => module.BankmoduleModule),
  },
  {
    path: '',
    component: SecondaryNavigationComponent,
    outlet: 'secondaryNavigation',
  },
  {
    path: '**',
    loadChildren: () => import('./not-found/not-found.module').then(module => module.NotFoundModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
